import model from "../models/current_positions";

export default () => {
  return {
    data: model(),
  };
};
